if (!customElements.get('product-form')) {

  customElements.define('product-form', class ProductForm extends HTMLElement {

    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cartPopup = document.querySelector('#PopupModal-custom_popup_wMEy7t');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.subitems = document.querySelector('sub-items');
      this.ID = this.uniqueID();

      // 🔥 Store cart count here
      this.initialCartCount = 0;
      this.loadInitialCartCount();
    }

    uniqueID() {
      return 'id' + (new Date()).getTime();
    }

    /* --------------------------
       LOAD CART COUNT ONCE
    -------------------------- */

    async loadInitialCartCount() {
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) return;

        const cart = await response.json();
        this.initialCartCount = cart.item_count || 0;

        console.log('Stored cart count:', this.initialCartCount);

      } catch (error) {
        console.error('Cart load failed:', error);
      }
    }

    /* --------------------------
       ADD SUB ITEMS
    -------------------------- */

    async addSubItems() {
      const variants = this.subitems.getVariants();
      this.handleErrorMessage();

      if (!variants.length) {
        this.handleErrorMessage('Please select how would you like your digitized media');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return false;
      }

      const data = {
        items: variants.map(variant => ({
          id: variant.id,
          quantity: 1,
          properties: { "_joinID": this.ID }
        }))
      };

      return fetch(`${routes.cart_add_url}`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
    }

    /* --------------------------
       SUBMIT HANDLER
    -------------------------- */

    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();

      // 🔥 Use stored cart count
      if (this.initialCartCount > 0 && this.cartPopup) {
        this.cartPopup.show();
        return;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const response = await this.addSubItems();
      if (!response || !response.ok) return false;

      const subitemsVariants = this.subitems.getVariants();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);

        if (subitemsVariants.length) {
          subitemsVariants.forEach((subitem, index) => {
            formData.append(`properties[Storage Option #${index}]`, subitem.name.split('-')[0]);
          });
          formData.append('properties[_joinID]', this.ID);
        }

        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }
          this.error = false;
        })
        .catch(e => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('loading');

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          window.location = window.routes.cart_url;
        });
    }

    /* --------------------------
       ERROR HANDLER
    -------------------------- */

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}